import useFetch from '@hooks/useFetch';

const useLessonDetails = (
  playlistUID,
  options = { fallbackData: undefined }
) => {
  const key = `v1/curated_content/${playlistUID}/content-header/`;
  const { data, mutate, ...rest } = useFetch(
    key,
    {},
    { fallbackData: options.fallbackData }
  );

  return {
    key,
    lessonDetails: data?.data?.[0] || {},
    learnerMeta: data?.learnerMeta,
    mutate,
    ...rest
  };
};

export default useLessonDetails;
